import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PublicHeaderService{

  constructor() {
  }

  public showProgramToggler = new BehaviorSubject(true);

  isLoggedExclusion(event: NavigationEnd) {
    return !(
      event.url === RoutesConst.AcceptTerm ||
      event.url === RoutesConst.Login ||
      event.url === RoutesConst.DevLoginPage
    );
  }

  isMenuButtonDisplayed(event: NavigationEnd) {
    return !(
      event.url.startsWith(RoutesConst.AccountProfile_FirstTimeSetup) ||
      event.url.startsWith(RoutesConst.PortalRegistrationStatus) ||
      event.url.startsWith(RoutesConst.Bn9Registration_Address) ||
      event.url.startsWith(RoutesConst.Bn9Registration_BusinessActivity) ||
      event.url.startsWith(RoutesConst.Bn9Registration_Contacts) ||
      event.url.startsWith(RoutesConst.Bn9Registration_LegalEntity) ||
      event.url.startsWith(RoutesConst.Bn9Registration_LegalName) ||
      event.url.startsWith(RoutesConst.Bn9Registration_Ownership) ||
      event.url.startsWith(RoutesConst.Bn9Registration_SubmitFailed) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_ReviewBusinessInformation) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_AuthorizedOfficials) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_ValidationRegistrationConflict) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_ValidateTransactions) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_BusinessContacts) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_LinkBusinessSuccessful) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_AddAttachments) ||
      event.url.startsWith(RoutesConst.PortalRequirements_SelectRegistrationType) ||
      event.url.startsWith(RoutesConst.PortalRegistrationStatus) ||
      event.url.startsWith(RoutesConst.PortalRegistrationStatus_Drafts) ||
      event.url.startsWith(RoutesConst.PortalRequirements) ||
      event.url.startsWith(RoutesConst.PortalRequirements_ConfirmRegistrationType) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_SelectProgramType.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_Importer.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_ProgramEnrolmentPayments.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_Thirdparty.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_Exporter.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_FailedSubmit.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_Carrier.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_UploadEnrolment.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_Pending) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_Drafts) ||
      event.url.startsWith(RoutesConst.AccountProfile_PersonalProfile.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.RegisterBusiness_AddAttachments) ||
      event.url.startsWith(RoutesConst.ProgramEnrolment_SuccessfulSubmit.toOrphanUrl()) ||
      event.url.startsWith(RoutesConst.error404)
    );
  }

  publicHeader(event: NavigationEnd) {
    return (
      event.url === RoutesConst.PublicHome ||
      event.url === RoutesConst.PublicRoot ||
      event.url === RoutesConst.PublicCarmApi ||
      event.url === RoutesConst.PublicCarmTarifCodes ||
      event.url === RoutesConst.PublicCustomBrokers ||
      event.url === RoutesConst.PublicDutiesTaxCalculator ||
      event.url === RoutesConst.PublicBulletins ||
      event.url === RoutesConst.PublicNationalRulings ||
      event.url === RoutesConst.PublicNationalRulingsDetails
    );
  }

  removeHashTag = hashtag => {
    const regexp = /\#\w\w+\s?/g;
    return hashtag.replace(regexp, '');
  };
}
